/* eslint-disable jsx-a11y/label-has-associated-control */
import {
	Button, Modal, Alert
} from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

/**
 * Component for DeleteEmailConfirmation  - Inactivating Subscriptions
 *
 * @class DeleteEmailConfirmation
 * @extends {Component}
 */
const DeleteEmailConfirmation = ({
	communityName, npi, sendingFacilityDisplayName, directAddress, isActive, onClickInactivate, onDeleteEmailModalClose, errorMsg
}) => {

	const [deleteMultiple, setDeleteMultiple] = useState(false);
	let alert = null;

	if (errorMsg) {
		const alertProps = {
			children: errorMsg,
			type: 'danger',
			visible: true,
			dismissable: false
		};
		alert = <Alert {...alertProps} />;
	}

	const content = (
		<div className='container'>
			{alert}
			<span className='mt-2'>
				<div className='mb-3'>
					<div>
						<b>NPI: </b>
						{npi}
					</div>
					<div>
						<b>Sending Facility: </b>
						{sendingFacilityDisplayName}
					</div>
					<div>
						<b>Direct Address: </b>
						{directAddress}
					</div>
				</div>
				{
					(isActive || isActive === 'undefined')
						? <span>If you would like to restore this email address for all existing subscriptions in this community for this provider,<br/>
						  check the box below.</span>
						: <span>If you would like to delete this email address for all existing subscriptions in this community for this provider,<br/>
						  check the box below. This will not prevent future subscriptions from being created with that email address.</span>

				}

				<br />
				<br />
				<label className='d-block' htmlFor='deleteMultiple' style={{ cursor: 'pointer' }}>
					<input
						className='mr-3'
						name='deleteMultiple'
						type='checkbox'
						value={deleteMultiple}
						onChange={(e) => handleCheck(e)}
						checked={deleteMultiple}
						style={{ cursor: 'pointer' }}
					/>
					{(isActive || isActive === 'undefined')
						? <span>Restore all existing subscriptions for this provider and this email within <b>{communityName}</b></span>
						: <span>Delete all existing subscriptions for this provider and this email within <b>{communityName}</b></span>
					}
				</label>
			</span>
		</div>
	);

	const handleCheck = (e) => {
		setDeleteMultiple(e.target.checked);
	}

	return (
		<Modal
			title={(isActive || isActive === 'undefined')
				? 'Restore Subscription'
				: 'Delete Subscription'}
			content={content}
			show
			classNames='resubscribeEmailModal'
			onClose={() => onDeleteEmailModalClose()}
			closeLabel='Discard'
			buttons={[
				<Button
					id='unsubscribe'
					key='unsubscribe'
					className='btn-success'
					onClick={() => onClickInactivate(deleteMultiple)}
				>
					Confirm
				</Button>]}
		/>
	);
};

DeleteEmailConfirmation.propTypes = {
	subscriptionId: PropTypes.string,
	communityId: PropTypes.string,
	npi: PropTypes.string,
	sendingFacilityDisplayName: PropTypes.string,
	directAddress: PropTypes.string,
	isActive: PropTypes.bool,
	onClickInactivate: PropTypes.func.isRequired,
	onDeleteEmailModalClose: PropTypes.func.isRequired
};

export default DeleteEmailConfirmation;
